export default __webpack_public_path__ + "static/media/fix-it.aedf3f9c.gif";